import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface ProjectNameDTO {
  name: string;
}

export class ProjectName {
  readonly isProjectNameProjectName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "minSize": 4,
      "maxSize": 128,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    ProjectName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: ProjectNameDTO): ProjectName {
    const name = getString(dto, "name", InvalidProjectNameNameError);
    return new ProjectName(
      name
    );
  }

  toDTO(): ProjectNameDTO {
    const dto: ProjectNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length < 4) {
      throw new InvalidProjectNameNameMinSizeError(
        4,
        `Attribute name is too short. Size is ${name.length}. Min size is 4.`
      );
    }
    if(name.length > 128) {
      throw new InvalidProjectNameNameMaxSizeError(
        128,
        `Attribute name is too long. Size is ${name.length}. Max size is 128.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidProjectNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

ProjectName.prototype.toString = function toString(): string {
  return `ProjectName(name='${this.name}')`;
};

export class InvalidProjectNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectNameError";
  }
}
export class InvalidProjectNameNameError extends InvalidProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectNameNameError";
  }
}

export class InvalidProjectNameNameMaxSizeError extends InvalidProjectNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectNameNameMaxSizeError";
  }
}

export class InvalidProjectNameNameMinSizeError extends InvalidProjectNameNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectNameNameMinSizeError";
  }
}

export class InvalidProjectNameNameNonEmptyError extends InvalidProjectNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectNameNameNonEmptyError";
  }
}
